import processClient from '.'
import { getAuthHeaders } from 'utils/requests'
import { cacheClear } from 'utils/memoryCache'

const updateProcess = async (id, body) => {
  const headers = { headers: getAuthHeaders() }
  const response = await processClient.patch(`/save/${id}`, body, headers)
  cacheClear('processes:')
  return response
}

export default updateProcess

